import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useRefreshEffect } from "@/context/RefreshContext";
import { PhoneCall } from "lucide-react";

const EMPTY = { sadcr: ["", "", ""], parole: ["", "", ""] };

export default function LeitstellenTelefone() {
  const [officers, setOfficers] = useState([]);
  const [sel, setSel] = useState(EMPTY);

  const load = useCallback(() => {
    api.get("/officers").then((r) => setOfficers((r.data || []).filter((o) => o.name !== "Administration"))).catch(() => {});
    api
      .get("/leitstellentelefone")
      .then((r) => setSel({ sadcr: r.data.sadcr || ["", "", ""], parole: r.data.parole || ["", "", ""] }))
      .catch(() => {});
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useRefreshEffect(load);

  const update = async (bereich, idx, value) => {
    const next = { sadcr: [...sel.sadcr], parole: [...sel.parole] };
    next[bereich][idx] = value;
    setSel(next);
    try {
      await api.post("/leitstellentelefone", next);
    } catch (e) {
      toast.error("Speichern fehlgeschlagen");
      load();
    }
  };

  const optLabel = (o) => `${o.name}${o.dienstnummer ? ` · ${o.dienstnummer}` : ""}`;

  const renderBox = (bereich, title, testid) => {
    const chosenHere = new Set(sel[bereich].filter(Boolean));
    return (
    <div
      data-testid={testid}
      className="bg-[#0C0E12] border border-zinc-800 rounded-sm px-3 py-2.5 w-[170px]"
    >
      <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-500 flex items-center gap-1.5 mb-2">
        <PhoneCall className="h-3.5 w-3.5 text-primary" /> {title}
      </div>
      <div className="space-y-1.5">
        {[0, 1, 2].map((idx) => {
          const current = sel[bereich][idx] || "";
          return (
            <select
              key={idx}
              data-testid={`${testid}-slot-${idx}`}
              value={current}
              onChange={(e) => update(bereich, idx, e.target.value)}
              className="w-full max-w-full truncate bg-zinc-900 border border-zinc-800 rounded-sm px-2 py-1 text-xs text-zinc-200 font-mono focus:outline-none focus:border-primary/60 hover:border-zinc-700 transition-colors duration-150"
            >
              <option value="">— frei —</option>
              {officers.map((o) => {
                const id = o.id;
                const disabled = chosenHere.has(id) && id !== current;
                return (
                  <option key={id} value={id} disabled={disabled}>
                    {optLabel(o)}
                  </option>
                );
              })}
            </select>
          );
        })}
      </div>
    </div>
    );
  };

  return (
    <div className="flex items-stretch gap-2">
      {renderBox("sadcr", "SADCR", "leitstelle-sadcr")}
      {renderBox("parole", "Parole", "leitstelle-parole")}
    </div>
  );
}
